export enum StatusQuestionarioStudente {
    aperta = 'APERTA',
    consegnata = 'CONSEGNATA',
    cancellata = 'CANCELLATA' // Cancellazione logica al DB
}